const AUTH_CONFIG = {
};

export default AUTH_CONFIG;
